import { Outlet } from "react-router-dom";

export const ChatLayout = () => {
  return (
    <div className="h-full flex flex-col overflow-hidden">
      <Outlet />
    </div>
  );
};

export default ChatLayout;
